import { render, staticRenderFns } from "./TalkRead.vue?vue&type=template&id=a0ce692e"
import script from "./TalkRead.vue?vue&type=script&lang=js"
export * from "./TalkRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports